import React from 'react';
import { clsx } from 'clsx';
import { type WeightUnit } from '../../hooks/useWeightUnit';

interface UnitToggleProps {
  unit: WeightUnit;
  onToggle: (unit: WeightUnit) => void;
  className?: string;
  disabled?: boolean;
}

export const UnitToggle: React.FC<UnitToggleProps> = ({ unit, onToggle, className, disabled = false }) => {
  return (
    <div className={clsx("flex items-center bg-gray-100 rounded-lg p-1", className)}>
      <button
        type="button"
        onClick={() => {
          if (disabled) return;
          onToggle('gram');
        }}
        disabled={disabled}
        className={clsx(
          "px-4 py-1 text-xs font-bold rounded-md transition-all",
          unit === 'gram'
            ? "bg-primary-500 text-gray-100 shadow-sm"
            : "text-gray-500 hover:text-gray-700",
          disabled && "cursor-not-allowed opacity-70 hover:text-gray-500"
        )}
      >
        g
      </button>
      <button
        type="button"
        onClick={() => {
          if (disabled) return;
          onToggle('kg');
        }}
        disabled={disabled}
        className={clsx(
          "px-4 py-1 text-xs font-bold rounded-md transition-all",
          unit === 'kg'
            ? "bg-primary-500 text-gray-100 shadow-sm"
            : "text-gray-500 hover:text-gray-700",
          disabled && "cursor-not-allowed opacity-70 hover:text-gray-500"
        )}
      >
        kg
      </button>
    </div>
  );
};
